module.exports = __webpack_public_path__ + "static/media/tip.1e5ae575.svg";